globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};

appCustomerSpace.Controllers.MainController = (function () {

  function MainController() {
    this.$body = $('body');
    this.init();
  }

  MainController.prototype.init = function () {
    appCustomerSpace.LimitlessPlugins.initPlugins();
    appCustomerSpace.Modules.initModules();
    appCustomerSpace.Plugins.initPlugins();
    appCustomerSpace.ModalOpener.initModalOpeners();
    appCustomerSpace.ModalOpener.openFromUrlParam();

    appCustomerSpace.Modules.NotificationFlash.initFlash();
    appCustomerSpace.Modules.TasksProjects.initTasksProjects();

    appCustomerSpace.Modules.AdminTopBar = new appCustomerSpace.Modules.AdminTopBar();
    appCustomerSpace.Modules.MainNavigation = new appCustomerSpace.Modules.MainNavigation();
    appCustomerSpace.Modules.SecondaryNavigation = new appCustomerSpace.Modules.SecondaryNavigation();
    appCustomerSpace.Modules.MobileNavigation = new appCustomerSpace.Modules.MobileNavigation();
    appCustomerSpace.Modules.Notifications = new appCustomerSpace.Modules.Notifications();
    appCustomerSpace.Modules.NpsReminder = new appCustomerSpace.Modules.NpsReminder();
    appCustomerSpace.Modules.Coaching = new appCustomerSpace.Modules.Coaching();

    CalendlyModule.initWidgets();

    this._globalEvents();
  };

  MainController.prototype._globalEvents = function () {
    var controller = this,
      allowLoader = true;

    $('a[data-no-loader]').on('click', function (e) {
      allowLoader = false;

      setTimeout(function () {
        allowLoader = true;
      }, 1000);
    });

    window.onbeforeunload = function (event) {
      if (allowLoader) {
        appCustomerSpace.Loader().start({ $container: $('.main-content-container'), options: { text: false, icon_size: '3x' } });
      }
    }

    window.addEventListener('unload', function () {
      appCustomerSpace.Loader().stop();
    });

    $('.loading').each(function () {
      appCustomerSpace.Loader().start({ $container: $(this), options: { text: $(this).data('loader-text'), icon_size: '2x' } });
    });

    var $content = $('.content'),
      $footer = $('.footer ');

    if ($content.length) {
      var contentHeight = $(window).height() - $content.offset().top;

      if ($footer.length) {
        contentHeight -= $footer[0].getBoundingClientRect().height;
      }

      $content.css('min-height', contentHeight + 'px')
    }

    if (controller.$body.find('.open-temporary-password').length) {
      if (!utils.cookies.get('customer_space.account.hide_temporary_password_modal')) {
        setTimeout(function () {
          controller.$body.find('.open-temporary-password').trigger('click');
        }, 2000)
      }
    }

    if (controller.$body.find('.trigger-click-on-load').length) {
      controller.$body.find('.trigger-click-on-load').first().trigger('click');
    }

    if (controller.$body.find('.bottom-fixed-banner').length) {
      const $fixedBanner = controller.$body.find(".bottom-fixed-banner");

      controller.$body.find('.main-content').scroll(function () {
        var scroll = $(this).scrollTop();
        if (scroll > 100) {
          $fixedBanner.addClass("visible");
        } else {
          $fixedBanner.removeClass("visible");
        }
      });

      // Detect Scroll Down and Up in mobile(android|ios)
      let touchStartPosX = 0;
      $(window).on('touchmove', (e) => {
        const currentPageX = Math.round(e.originalEvent.touches[0].screenY);
        if (touchStartPosX === currentPageX) return;

        if (touchStartPosX - currentPageX > 0) {
          $fixedBanner.addClass("visible");
        } else {
          $fixedBanner.removeClass("visible");
        }
        touchStartPosX = currentPageX;
      });
    }

    // Progressive Web App
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

    if (document.referrer.startsWith('android-app://')) {
      // android app
    } else if (navigator.standalone || isStandalone) {
      // apple app
    } else {
      // browser
      if (controller.$body.find('.open-add-to-home-screen').length) {
        setTimeout(function () {
          controller.$body.find('.open-add-to-home-screen').trigger('click');
        }, 2000)
      };

    }
  }

  return MainController;
})();
